import { marker } from '@jsverse/transloco-keys-manager/marker';
import { Attachment } from '@shared/models/attachments/attachment';
import { Table } from '../models/table';

const TABLE_ITEM_HEIGHT = 60;

export const ATTACHMENT_TABLE_CONFIG: Table<Attachment> = {
  virtualScroll: {
    itemSize: TABLE_ITEM_HEIGHT,
    maxBuffer: TABLE_ITEM_HEIGHT * 25,
    minBuffer: TABLE_ITEM_HEIGHT * 15,
  },
  headers: [
    {
      column: 'name',
      name: marker('Nom'),
      classes: 'border-t-0!',
      sorter: (a: Attachment, b: Attachment): number => a.originalFilename.localeCompare(b.originalFilename),
    },
    {
      column: 'type',
      name: marker('Type'),
      classes: 'border-t-0! min-w-24! max-w-24! w-24!',
      sorter: (a: Attachment, b: Attachment): number => a.extension.localeCompare(b.extension),
    },
    {
      column: 'createdBy',
      name: marker('Créé par'),
      classes: 'border-t-0! min-w-48! max-w-48! w-48!',
      sorter: (a: Attachment, b: Attachment): number =>
        a.createdBy.firstName.localeCompare(b.createdBy.firstName) ||
        a.createdBy.lastName.localeCompare(b.createdBy.lastName),
    },
    {
      column: 'createdOn',
      name: marker('Date'),
      classes: 'border-t-0! min-w-40! max-w-40! w-40!',
      sorter: (a: Attachment, b: Attachment): number => a.createdOn.getTime() - b.createdOn.getTime(),
    },
    {
      column: 'actions',
      name: '',
      classes: 'border-t-0! min-w-32! max-w-32! w-32!',
    },
  ],
};
